<div class="my-5 pt-5">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <div class="text-center mb-5">
          <h1 class="display-1 fw-semibold">
            4
            <span class="text-danger mx-2">0</span>
            3
          </h1>
          <h4 class="text-uppercase mb-3">Acesso Negado</h4>
          <p class="text-muted mb-4 fs-5">
            Você não tem permissão para acessar este recurso.
          </p>
          <p class="text-muted mb-0">
            Se você já recebeu o acesso, realize o login novamente.
          </p>
          <p class="text-muted mb-0">
            Se você acredita que deveria ter acesso, entre em contato com o administrador do sistema.
          </p>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-md-10 col-xl-8">
        <div>
          <img src="assets/images/error-img.png" alt="Acesso Negado" class="img-fluid" />
        </div>
      </div>
    </div>
  </div>
</div>
